<template>
  <div>
<!--    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>-->
    <v-row>
      <v-col class="d-flex pt-0">
        <img
          src="../../assets/icons/sorts/resource_center.png"
          class="tcdc-resource-center-layout-icon mr-4"
        />
<!--        <span class="text-tcdc-green bold header text-uppercase">{{$t('resourceCenter.resourceCenter')}}</span>-->
        <span class="text-tcdc-green bold header text-uppercase">{{resource[`name_${lang}`]}}</span>
      </v-col>
    </v-row>
    <v-row class="my-8">
      <v-col>
<!--        <span-->
<!--          class="header bold grey&#45;&#45;text"-->
<!--        >{{$t('resourceCenter.headerContent')}}-->
<!--        </span>-->
          <span class="header bold grey--text" v-html="resource[`description_${lang}`]"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ResourceCenterExpandable
          :items="resourceCenterList"
          @onPress="onPress"
          :bottomBorderVisible="false"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResourceCenterExpandable from "../../components/expandables/ResourceCenterExpandable";
import { mapState } from 'vuex';

export default {
  components: {
    ResourceCenterExpandable
  },
  created() {
    this.items[0].text = this.branchName;
  },
  computed: {
    ...mapState({
        branchName: state => state.Branch.branch_name,
        resourceCenterList : state=> state.ServiceMenu.resource_center,
        lang: state => state.Branch.lang,
        resource : state=>{
            return state.ServiceMenu.resource_center_main;
        },
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/"
      },
      {
        text: "PROGRAM",
        disabled: true,
      }
    ],
  }),
  methods: {
    onPress(item) {
      try {
        const path = item.path;
        this.$router.push(path);
      } catch (e) {
        console.log("Can't open page", e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-resource-center-icon {
  height: 35px;
  object-fit: contain;
}
</style>
